import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGuidelinesList,
  type GuidelineApiItem,
  getStateList,
  type StateOption
} from "../../services/apiEndpoints";
// import { getPublicUrlAPI } from "@modules/provisional-payment/services/apiEndpoints";
import { getPublicUrlAPI } from "@modules/public-comments/services/apiEndpoints";

export const fetchGuidelines = createAsyncThunk<
  GuidelineApiItem[],
  { category?: string } | undefined,
  { rejectValue: string }
>("guidelines/fetchGuidelines", async (payload, { rejectWithValue }) => {
  try {
    const category = payload?.category;
    const res = await getGuidelinesList(category);
    const publishedData = res?.data?.data;

    const permissionList: GuidelineApiItem[] = Array.isArray(
      publishedData?.permission_guidelines
    )
      ? publishedData.permission_guidelines
      : [];

    const generalList: GuidelineApiItem[] = Array.isArray(
      publishedData?.general_guidelines
    )
      ? publishedData.general_guidelines
      : [];

    if (category && category.toLowerCase() === "row") {
      return permissionList;
    }

    // Prefer general guidelines if present, otherwise fallback to permission list
    if (generalList.length > 0) return generalList;
    if (permissionList.length > 0) return permissionList;

    return [];
  } catch (err: any) {
    return rejectWithValue(
      err?.response?.data ?? err?.message ?? "Failed to fetch guidelines"
    );
  }
});

export const getStateListThunk = createAsyncThunk<
  StateOption[],
  void,
  { rejectValue: string }
>("publicComments/getStateList", async (_, { rejectWithValue }) => {
  try {
    const list = await getStateList();
    return list;
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data ?? error?.message ?? "Failed to fetch states"
    );
  }
});

export const getPublicUrlThunk = createAsyncThunk<
  any,
  { document_name: string; moduletype: string },
  { rejectValue: string }
>(
  "file/getPublicUrl",
  async ({ document_name, moduletype }, { rejectWithValue }) => {
    try {
      const response = await getPublicUrlAPI({ document_name, moduletype });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data ?? error?.message ?? "Failed to fetch file"
      );
    }
  }
);
